import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-application-help',
  templateUrl: './application-help.component.html',
  styleUrls: ['./application-help.component.css']
})
export class ApplicationHelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
